import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CaseDetail } from '../cases/case-detail';
import { CaseService } from '../cases/case.service';
import { Case } from '../cases/models/case';
import { OroService } from '../oroservice';

@Component({
    selector: 'app-customer-account',
    templateUrl: './customer-account.component.html',
    styleUrls: ['./customer-account.component.scss'],
    standalone: false
})
export class CustomerAccountComponent implements OnInit {
    private readonly caseService = inject(CaseService);
    kontoColumns: string[] = ['Datum', 'Bemerkung', 'Schuldner', 'Betrag', 'Saldo'];
    Zeitraum: number = 0;
    Von: Date = null;
    Bis: Date = null;
    kontoauszug: Array<any> = [];
    isLoading: boolean = false;
    errorMessage: string = null;

    constructor(public oroservice: OroService,
        private datePipe: DatePipe,
        public translate: TranslateService,
        public dialog: MatDialog) { }

    public ngOnInit(): void {
        this.isLoading = true;
        this.oroservice.getKundenInfo();
        const now = new Date();

        this.Von = new Date(now.getFullYear(), now.getMonth(), 1);
        this.Bis = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        this.refresh();
    }

    refresh() {
        const validationError = this.validateDates();
        if (validationError) {
            this.errorMessage = validationError;
            return;
        }

        this.errorMessage = null;
        this.isLoading = true;
        this.oroservice.getKonto(this.Von.toDateString(), this.Bis.toDateString()).then((object) => {
            this.kontoauszug = object;
            this.isLoading = false;
        });
    }

  openCaseDialog(selectedCase: Case): void {
    this.dialog.open(CaseDetail, {
      width: "850px",
      disableClose: true,
      data: { dossierinfo: selectedCase },
      autoFocus: false
    });
  }
    
    public async selectRow(row: { Dossier: number }): Promise<void> {
        if (row.Dossier > 0) {
            const loadedCase = await this.caseService.getCase(row.Dossier);
            if (loadedCase != null) {
                this.openCaseDialog(loadedCase);
            } else {
                // TODO
            }
        }
    }

    public calcZeitraum(): void {
        const zeitraum = this.Zeitraum.toString();
        const now = new Date();

        let von: Date;
        let bis: Date;

        if (zeitraum === "3") {
            return;
        }

        switch (zeitraum) {
            case "0":
                von = new Date(now.getFullYear(), now.getMonth(), 1);
                bis = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                break;

            case "1":
                const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                von = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1);
                bis = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0);
                break;

            case "2":
                von = new Date(now.getFullYear(), 0, 1);
                bis = new Date(now.getFullYear(), 11, 31);
                break;

            default:
                von = new Date(now.getFullYear(), now.getMonth(), 1);
                bis = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        }

        this.Von = von;
        this.Bis = bis;

        this.refresh();

    }

    validateDates(): string {
        if (!this.Von || !this.Bis) {
            return null;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const von = new Date(this.Von);
        von.setHours(0, 0, 0, 0);

        const bis = new Date(this.Bis);
        bis.setHours(0, 0, 0, 0);

        if (von > today) {
            return 'DatumZukunft';
        }

        if (von > bis) {
            return 'Kundenkonto.DatumVonNachDatumBisFehler';
        }

        return null;
    }

    checkColor(element) {
        return element.Kundenkontohaben || element.Betrag === 0.00;
    }

    checkColorSaldo(element) {
        return element.Saldo >= 0.00;
    }

    checkFontWeight(element) {
        return this.checkAnfangOrEndSaldo(element);
    }

    checkAnfangOrEndSaldo(element) {
        return element.Anfangssaldo || element.Endsaldo;
    }

    checkBetrag(element): number {
        let betrag : number = element.Betrag;
        const negate = -1;
        if (!this.checkColor(element))
        {
            betrag = betrag * negate;
        }

        return betrag;
    }

    saldoToString(element): string {
        let betrag = this.checkSaldo(element);
        return betrag.toFixed(2);
    }

    betragToString(element): string {
        let betrag = this.checkBetrag(element);
        return betrag.toFixed(2);
    }

    checkSaldo(element): number {
        let saldo: number = element.Saldo;
        const negate = -1;
        if (!this.checkColor(element)) {
            saldo = saldo * negate;
        }

        return saldo;
    }
}
